import React, { createContext, useContext } from 'react'

const HistoryModeContext = createContext({ isInHistory: false });

export const HistoryModeProvider = ({ children }) => {
  const context = { isInHistory: true };
  return <HistoryModeContext.Provider value={context}>{children}</HistoryModeContext.Provider>
}

export const useHistoryMode = () => useContext(HistoryModeContext);
